import styled, { css } from "@digits-css"
import { isDigitsMacApp } from "@digits-shared/helpers/devicesHelper"
import borders from "@digits-shared/themes/borders"
import fonts from "@digits-shared/themes/typography"
import "./Container.digits.css"

export const SITE_WIDTH = 1200
export const SITE_CENTER_CONTENT_PADDING = 145
export const SITE_CENTER_CONTENT_WIDTH = SITE_WIDTH - SITE_CENTER_CONTENT_PADDING * 2

export const PAGE_HEADER_HEIGHT = isDigitsMacApp ? 140 : 152

export const CENTERED_DIALOG_CONTAINER_HEIGHT = "700px"
export const CENTERED_DIALOG_CONTAINER_WIDTH = "460px"

export const CENTERED_DIALOG_CONTAINER_PARENT_STYLES = css`
  .desktop & {
    padding: 80px 20px 0 20px;
    @media only screen and (max-height: 800px) {
      padding-top: 50px;
    }
  }
  .mobile & {
    padding-top: 50px;
  }

  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: content-box;
`

export const CenteredDialogContainer = styled.section({ cls: "Container__CenteredDialogContainer_86ec84c" })
